module.exports = __webpack_public_path__ + "img/down-active.e992124.png";